import { z } from 'zod';

export const AuditEntry = z.object({
  id: z.string(),
  ts: z.number().int(),
  actor_email: z.string(),
  actor_role: z.string(),
  target_workspace: z.string().nullable().optional(),
  action: z.string(),
  before_json: z.string().nullable().optional(),
  after_json: z.string().nullable().optional(),
  reason: z.string().nullable().optional(),
  thread_id: z.string().nullable().optional(),
});
export type AuditEntry = z.infer<typeof AuditEntry>;

export const AuditListResponse = z.object({
  entries: z.array(AuditEntry),
  next_cursor: z.string().nullable().optional(),
});
export type AuditListResponse = z.infer<typeof AuditListResponse>;
